export enum PartyType {
  CLIENT = <any>'CLIENT',
  PROPERTY = <any>'PROPERTY',
  AGENCY = <any>'AGENCY'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/party-type.ts